import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';

export class MmValidators {
    static required(message?: string | Observable<any>): ValidatorFn {
        return (control: AbstractControl) => {
            if (!control.value || control.value.length == 0) {
                return {
                    required: {
                        message
                    }
                }
            }
            // for (const lang of langs) {

            //     if (!control.value[lang]) {

            //         return {
            //             required: {
            //                 lang: lang
            //             }
            //         };
            //     }
            // }
            return null;
        }

    }

    static requiredLangs(langs: string[]) {
        return (control: AbstractControl) => {

            if (!control.value) {
                return {
                    required: true
                }
            }
            if (Object.entries(control.value).length === 0) {
                return {
                    required: true
                }
            }
            for (const lang of langs) {

                if (!control.value[lang]) {

                    return {
                        requiredLang: {
                            lang: lang
                        }
                    };
                }
            }
            return null;
        }

    }
    static minlength(minlength: number): ValidatorFn {
        return (control: AbstractControl) => {

            if (control.value === undefined || control.value === null) {
                return null;
            }
            if (typeof control.value === "string") {
                let str = control.value as string;
                if (str.length < minlength) {
                    return {
                        minlength: {
                            minlength: minlength,
                            length: str.length
                        }
                    }
                }
                return null;
            }
            else if (typeof control.value === "object") {
                const langs = ["en", "zh", "fr", "jp"]
                for (const lang of langs) {

                    let str = control.value[lang] as string;
                    if (!str) continue;
                    // debugger;
                    if (str.length < minlength) {
                        // const errs = {};
                        // errs[`minlength_${length}`] = true;
                        return {
                            minlength: {
                                lang: lang,
                                minlength: minlength,
                                length: str.length
                            }
                        }
                    }



                }


            }




        }

    }

    static custom(fn: (control: AbstractControl) => string | Observable<any>): ValidatorFn {

        return c => {
            var msg = fn(c);
            if (msg) {
                const result = {};
                result["custom"] = {
                    message: msg
                }
                return result
            }
            return null;
        }
    }
}
